import { useHead } from "../services/common";

import Content from "../components/Content";

export default function AboutUs() {

    useHead({
        title: "O nás – Historie a poslání | T.J. Sokol Poniklá",
        description: "Seznamte se s T.J. Sokol Poniklá. Naše historie sahá až do roku 1892. Přečtěte si o našem poslání, členech a aktivitách v obci Poniklá."
    });

    return <>
        <div className="header">
            <h1>O nás</h1>
        </div>
        <section className="width-max">
            <Content id="about-us" />
        </section>
    </>;
}